import { Box } from '@wishket/design-system';
import { ReactNode } from 'react';

interface GrassCalendarContainerProps {
  children: ReactNode;
}

export const GrassCalendarContainer = ({
  children,
}: GrassCalendarContainerProps) => {
  return (
    <Box className="grid grid-flow-col grid-rows-7 gap-0.5">{children}</Box>
  );
};

const A_WEEK = 7;
const WEEK_COUNT = 53;
export const DEFAULT_GRASS_COUNT = A_WEEK * WEEK_COUNT;
